/**
 * @typedef {import("../../types/directus").components["schemas"]["ItemsArticles"]} DirectusArticle
 */
import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

export function useAboutPageData() {
  const isValidId = Number.isFinite(Number(1));
  return useQuery({
    queryKey: ["about-page-data"],
    enabled: isValidId,
    /** @returns {Promise<DirectusArticle | null>} */
    queryFn: async () => {
      const fields = [
        "id",
        "translations.id",
        "translations.languages_code",
        "translations.title",
        "translations.subtitle",
        "translations.our_mission_title",
        "translations.our_mission_content",
        "translations.community_title",
        "translations.community_content",
        "translations.authenticity_title",
        "translations.authenticity_content",
        "translations.passion_title",
        "translations.passion_content",
        "translations.our_team_title",
        "translations.our_team_content",
        "translations.our_story_title",
        "translations.our_story_content",
      ].join(",");

      const json = await getJson(`/items/About_Page`, { fields });
      return json?.data?.[0] || null;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export default useAboutPageData;
